import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductGenderAsync,
  deleteProductGenderAsync,
  editProductStyleAsync,
  editProductGenderAsync,
  getProductStyleAsync,
  getProductGenderAsync,
} from "../../../../store/services/productInfoServices";
const Gender = () => {
  const dispatch = useDispatch();
  const {
    getProductGenderStatus,
    getProductGenderError,
    getProductGenderData,
    addProductGenderStatus,
    addProductGenderData,
    addProductGenderError,

    editProductGenderStatus,
    editProductGenderError,
    editProductGenderData,

    deleteProductGenderData,
    deleteProductGenderStatus,
    deleteProductGenderError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductGenderAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductGenderData?.length
    ? getProductGenderData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedGender, setSelectedGender] = useState();
  const [addGenderMode, setAddGenderMode] = useState(false);
  const [addGenderData, setAddGenderData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedGender", selectedGender);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductGenderStatus === asyncStatus.SUCCEEDED) {
      setAddGenderMode(false);
      setSaveDisabled(true);
      setAddGenderData();
    }
  }, [, addProductGenderStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductGenderAsync(selectedGender?.gender_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductGenderStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedGender();
    }
  }, [, deleteProductGenderStatus]);
  useEffect(() => {
    if (editProductGenderStatus === asyncStatus.SUCCEEDED) {
      setSelectedGender();
      setEditMode(false);
    }
  }, [, editProductGenderStatus]);
console.log("getProductGenderData",getProductGenderData,editProductGenderData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this Gender?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Gender"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Gender Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddGenderMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addGenderMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addGenderMode || !selectedGender}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddGenderMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addGenderMode || !selectedGender}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductGenderStatus === asyncStatus.LOADING ||
                  editProductGenderStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addGenderData) {
                    dispatch(addProductGenderAsync(addGenderData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedGender, ...editData };
                    delete a.id;
                    dispatch(editProductGenderAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "gender_id", headerName: "ID", flex: true },
                  {
                    field: "gender_name",
                    headerName: "Gender Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedGender(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductGenderStatus === asyncStatus.IDLE ||
                  getProductGenderStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addGenderMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Gender:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddGenderData({
                            ...addGenderData,
                            gender_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddGenderData({
                            ...addGenderData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedGender ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedGender?.gender_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Gender:",
                    comp: (
                      <InputComp
                        key={selectedGender?.gender_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            gender_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedGender?.gender_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedGender?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedGender?.is_active ? true : false
                        }
                        checked={selectedGender?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any gender</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductGenderError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductGenderError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductGenderError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductGenderError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedGender(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedGender(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default Gender;
